import { render, staticRenderFns } from "./tiktok-table.vue?vue&type=template&id=1b88aeb1&"
import script from "./tiktok-table.vue?vue&type=script&lang=js&"
export * from "./tiktok-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports